// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login .login-bg[data-v-64ec9185]{height:220px}.login .login-bg img[data-v-64ec9185]{height:100%;width:100%}.login .title[data-v-64ec9185]{font-size:20px;font-weight:600}.login .login-form[data-v-64ec9185]{width:80%;margin:0 auto}.login .login-form .forget-password[data-v-64ec9185]{padding:10px 0;text-align:right;color:#c5c5c5}.login .version[data-v-64ec9185]{position:fixed;bottom:15px;margin:auto;left:0;right:0}", ""]);
// Exports
module.exports = exports;
